export const ANALYTICS_ROOT = '/reporting'